/* eslint-disable react/no-unknown-property */
import { useGLTF } from '@react-three/drei';
import { Canvas, useFrame } from '@react-three/fiber';
import React, { Suspense, useRef } from 'react';
import * as THREE from 'three';

const Spacecraft: React.FC = () => {
  const { scene } = useGLTF('/spacecraft.glb');
  const spacecraftRef = useRef<THREE.Group>();

  useFrame(({ mouse }) => {
    if (spacecraftRef.current) {
      // 마우스 위치에 따라 우주선 회전
      spacecraftRef.current.rotation.y = mouse.x * Math.PI;
      spacecraftRef.current.rotation.x = mouse.y * Math.PI * 0.5;
    }
  });

  return (
    <primitive
      ref={spacecraftRef}
      object={scene}
      scale={[0.2, 0.2, 0.2]} // 크기 조절 (예: 0.5배로 축소)
      position={[0, 0, 0]} // 위치 조절 (예: 중앙에 위치)
    />
  );
};

const CameraControls: React.FC = () => {
  const camera = useRef<THREE.PerspectiveCamera>(null);

  useFrame(({ mouse }) => {
    if (camera.current) {
      camera.current.position.x = mouse.x * 2;
      camera.current.position.y = mouse.y * 2;
    }
  });

  return (
    <perspectiveCamera
      ref={camera}
      fov={75}
      aspect={window.innerWidth / window.innerHeight}
      near={0.1}
      far={1000}
      position={[0, 0, 5]}
    />
  );
};

const SpacecraftScene: React.FC = () => {
  return (
    <Canvas style={{ width: '100%', height: '100vh' }}>
      <ambientLight intensity={3} />
      <directionalLight position={[10, 10, 5]} intensity={3} />
      <Suspense fallback={null}>
        <Spacecraft />
      </Suspense>
      <CameraControls/>
    </Canvas>
  );
};

export default SpacecraftScene;
